export enum SERVER_TYPE {
  AUTH = 'AUTH',
  COMMON = 'COMMON',
  PUBLIC = 'PUBLIC',
  SOCKET = 'SOCKET',
  EDUPAD = 'EDUPAD',
  WBO = 'WBO',
  HEALTH = 'HEALTH'
}

export enum SERVER_HOSTNAME {
  AUTH = 'VUE_APP_AUTH_HOSTNAME',
  COMMON = 'VUE_APP_HOSTNAME',
  PUBLIC = 'VUE_APP_HOSTNAME_PUBLIC',
  SOCKET = 'VUE_APP_HOSTNAME_SOCKET',
  EDUPAD = 'VUE_APP_EDUAC_PAD_URL',
  WBO = 'VUE_APP_WBO_TASK_URL',
  HEALTH = 'VUE_APP_HOSTNAME_HEALTH'
}

export enum REQUEST_INFO {
  BASIC_AUTH_USER = 'eduac_webapp',
  BASIC_AUTH_PASSWORD = 'A1sGxRAFT3uCVSNl'
}
